module.exports = __webpack_public_path__ + "static/media/ncl_mobile_frontpage.a33bf596.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/ncl_mobile_frontpage.png
// module id = 383
// module chunks = 0